(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["music-fridge-customizer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('music-fridge-customizer')) {
    customElements.define(
      'music-fridge-customizer',
      class MusicFridgeCustomizer extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.catalog = this.parseJson('[data-music-magnet-catalog]', []);
          this.config = this.parseJson('[data-music-magnet-config]', {});
          this.variantBySku = new Map((this.config.variants || []).map((variant) => [variant.sku, variant]));
          this.form = document.getElementById(this.dataset.formId);
          this.productForm = this.form?.closest('product-form');
          this.submitButton = this.form?.querySelector('[name="add"]');
          this.placeholderUrl = this.config.placeholderUrl || '';
          this.state = { artist: '', song: null, cover: '', variant: null, uploadUrl: '' };
          this.searchTimer = null;
          this.searchAbortController = null;
          this.onSubmitBound = this.onSubmit.bind(this);
          this.cacheKey = `music-magnet-search-cache-${this.config.searchCountry || 'US'}`;
          this.rateKey = 'music-magnet-search-rate';
          this.cache = this.readSession(this.cacheKey, {});
          this.bindEvents();
          this.initializeState();
          this.form?.addEventListener('submit', this.onSubmitBound, true);
          this.updateAll();
        }

        disconnectedCallback() {
          this.form?.removeEventListener('submit', this.onSubmitBound, true);
          this.searchAbortController?.abort();
          if (this.state?.uploadUrl) URL.revokeObjectURL(this.state.uploadUrl);
        }

        parseJson(selector, fallback) {
          try {
            return JSON.parse(this.querySelector(selector)?.textContent || '');
          } catch {
            return fallback;
          }
        }

        readSession(key, fallback) {
          try {
            return JSON.parse(sessionStorage.getItem(key)) || fallback;
          } catch {
            return fallback;
          }
        }

        writeSession(key, value) {
          try {
            sessionStorage.setItem(key, JSON.stringify(value));
          } catch {
            return;
          }
        }

        bindEvents() {
          this.querySelectorAll('[data-artist]').forEach((input) => {
            input.addEventListener('change', () => this.selectArtist(input.value));
          });
          this.querySelectorAll('[data-cover]').forEach((input) => {
            input.addEventListener('change', () => this.selectCover(input.value));
          });
          this.querySelector('[data-cover-file]')?.addEventListener('change', (event) => this.selectFile(event));
          this.querySelector('[data-remove-file]')?.addEventListener('click', () => this.clearFile());
          this.querySelector('[data-search-input]')?.addEventListener('input', (event) => this.queueSearch(event.target.value));
          ['[data-manual-song]', '[data-manual-artist]', '[data-manual-link]'].forEach((selector) => {
            this.querySelector(selector)?.addEventListener('input', () => this.updateManualSong());
          });
          this.querySelectorAll('[data-edit-step]').forEach((button) => {
            button.addEventListener('click', () => {
              this.querySelector(`[data-step="${button.dataset.editStep}"]`)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            });
          });
          this.querySelector('[data-preview-open]')?.addEventListener('click', () => this.openPreview());
          this.querySelector('[data-preview-close]')?.addEventListener('click', () => {
            this.querySelector('[data-preview-dialog]')?.close();
          });
          this.querySelector('[data-preview-dialog]')?.addEventListener('click', (event) => {
            if (event.target === event.currentTarget) event.currentTarget.close();
          });
        }

        openPreview() {
          const dialog = this.querySelector('[data-preview-dialog]');
          const dialogImage = this.querySelector('[data-preview-dialog-image]');
          const preview = this.querySelector('[data-preview-image]');
          const fallback = this.querySelector('[data-preview-open] > img:not([data-preview-image])');
          const source = preview && !preview.hidden && preview.src ? preview : fallback;
          if (!dialog || !dialogImage || !source || typeof dialog.showModal !== 'function') return;
          dialogImage.src = source.currentSrc || source.src;
          dialogImage.alt = [this.state.song?.title, this.state.song?.artist].filter(Boolean).join(' — ');
          dialog.showModal();
        }

        initializeState() {
          const selectedVariant = (this.config.variants || []).find(
            (variant) => String(variant.id) === String(this.config.selectedVariantId)
          );
          const catalogSong = this.catalog.find((song) => song.sku === selectedVariant?.sku);
          if (catalogSong) {
            this.state.artist = catalogSong.artist;
            this.state.song = { ...catalogSong, source: 'preset' };
            this.state.cover = this.config.albumArtworkEnabled ? 'album' : '';
            this.state.variant = selectedVariant;
          } else if (selectedVariant?.sku === this.config.customSku) {
            this.state.artist = 'Custom Artist';
            this.state.variant = selectedVariant;
          } else {
            const firstSong = this.catalog[0];
            if (firstSong) {
              this.state.artist = firstSong.artist;
              this.state.song = { ...firstSong, source: 'preset' };
              this.state.cover = this.config.albumArtworkEnabled ? 'album' : '';
              this.state.variant = this.variantBySku.get(firstSong.sku) || null;
            }
          }
          const artistInput = Array.from(this.querySelectorAll('[data-artist]')).find(
            (input) => input.value === this.state.artist
          );
          if (artistInput) artistInput.checked = true;
          const coverInput = Array.from(this.querySelectorAll('[data-cover]')).find(
            (input) => input.value === this.state.cover
          );
          if (coverInput) coverInput.checked = true;
        }

        selectArtist(artist) {
          this.state.artist = artist;
          this.state.song = null;
          this.state.cover = '';
          this.state.variant = artist === 'Custom Artist' ? this.variantBySku.get(this.config.customSku) || null : null;
          this.clearFile();
          this.clearManualFields();
          this.clearSearch();
          this.querySelectorAll('[data-cover]').forEach((input) => {
            input.checked = false;
          });
          this.updateAll();
        }

        renderPresetSongs() {
          const container = this.querySelector('[data-preset-songs]');
          const searchPanel = this.querySelector('[data-search-panel]');
          if (!container) return;
          container.replaceChildren();
          const isCustom = this.state.artist === 'Custom Artist';
          if (searchPanel) searchPanel.hidden = !isCustom;
          if (isCustom) return;
          this.catalog.filter((song) => song.artist === this.state.artist).forEach((song) => {
            const variant = this.variantBySku.get(song.sku);
            const label = document.createElement('label');
            label.className = 'music-magnet__song-card';
            const input = document.createElement('input');
            input.type = 'radio';
            input.name = `music-magnet-song-${this.dataset.sectionId}`;
            input.value = song.id;
            input.checked = this.state.song?.id === song.id;
            input.disabled = !variant?.available;
            input.addEventListener('change', () => {
              this.state.song = { ...song, source: 'preset' };
              this.state.variant = variant;
              this.state.cover = this.config.albumArtworkEnabled ? 'album' : '';
              const albumCover = this.querySelector('[data-cover][value="album"]');
              if (albumCover) albumCover.checked = this.state.cover === 'album';
              this.updateAll();
            });
            const copy = document.createElement('span');
            const title = document.createElement('strong');
            title.textContent = song.title;
            const detail = document.createElement('small');
            detail.textContent = `${song.artist} · ${song.album}`;
            copy.append(title, detail);
            label.append(input, copy);
            container.append(label);
          });
        }

        selectCover(cover) {
          this.state.cover = cover;
          if (cover === 'album') this.clearFile();
          this.updateAll();
        }

        selectFile(event) {
          const file = event.target.files?.[0];
          this.setError('upload', '');
          if (!file) {
            this.clearFile();
            return;
          }
          if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) {
            this.setError('upload', this.config.messages.invalidFile);
            this.clearFile();
            return;
          }
          if (file.size > 10 * 1024 * 1024) {
            this.setError('upload', this.config.messages.largeFile);
            this.clearFile();
            return;
          }
          if (this.state.uploadUrl) URL.revokeObjectURL(this.state.uploadUrl);
          this.state.uploadUrl = URL.createObjectURL(file);
          const fileMeta = this.querySelector('[data-file-meta]');
          if (fileMeta) fileMeta.hidden = false;
          const fileName = this.querySelector('[data-file-name]');
          if (fileName) fileName.textContent = file.name;
          this.updateAll();
        }

        clearFile(resetInput = true) {
          if (this.state?.uploadUrl) URL.revokeObjectURL(this.state.uploadUrl);
          if (this.state) this.state.uploadUrl = '';
          const input = this.querySelector('[data-cover-file]');
          if (input && resetInput) input.value = '';
          const fileMeta = this.querySelector('[data-file-meta]');
          if (fileMeta) fileMeta.hidden = true;
          const fileName = this.querySelector('[data-file-name]');
          if (fileName) fileName.textContent = fileName.dataset.emptyLabel || '';
          this.updateAll?.();
        }

        clearManualFields() {
          ['[data-manual-song]', '[data-manual-artist]', '[data-manual-link]'].forEach((selector) => {
            const input = this.querySelector(selector);
            if (input) input.value = '';
          });
        }

        clearSearch() {
          const input = this.querySelector('[data-search-input]');
          if (input) input.value = '';
          const results = this.querySelector('[data-search-results]');
          results?.replaceChildren();
          if (results) results.hidden = true;
          const status = this.querySelector('[data-search-status]');
          if (status) status.textContent = '';
        }

        updateManualSong() {
          if (this.state.artist !== 'Custom Artist') return;
          const title = this.querySelector('[data-manual-song]')?.value.trim() || '';
          const artist = this.querySelector('[data-manual-artist]')?.value.trim() || '';
          const link = this.querySelector('[data-manual-link]')?.value.trim() || '';
          if (title && artist) {
            this.state.song = {
              id: '',
              title,
              artist,
              album: '',
              artwork: '',
              link,
              productionCode: 'PRO|CUSTOM',
              source: 'manual'
            };
            this.state.variant = this.variantBySku.get(this.config.customSku) || null;
          } else {
            this.state.song = null;
          }
          this.querySelector('[data-search-results]')?.querySelectorAll('[aria-pressed="true"]').forEach((button) => {
            button.setAttribute('aria-pressed', 'false');
          });
          this.updateAll();
        }

        queueSearch(value) {
          window.clearTimeout(this.searchTimer);
          this.searchAbortController?.abort();
          const query = value.trim();
          if (query.length < 2) {
            const results = this.querySelector('[data-search-results]');
            results?.replaceChildren();
            if (results) results.hidden = true;
            this.setSearchStatus('');
            return;
          }
          this.searchTimer = window.setTimeout(() => this.search(query), 450);
        }

        async search(query) {
          const normalized = query.toLowerCase();
          const localResults = this.catalog.filter((song) => {
            const haystack = [song.title, song.artist, song.album, ...(song.aliases || [])].join(' ').toLowerCase();
            return haystack.includes(normalized);
          }).slice(0, 8);
          if (localResults.length) {
            this.renderSearchResults(localResults.map((song) => ({ ...song, source: 'local-search' })));
            this.setSearchStatus(this.config.messages.results.replace('__COUNT__', String(localResults.length)));
            return;
          }
          if (!this.config.externalSearchEnabled) {
            this.renderSearchResults([]);
            this.setSearchStatus(this.config.messages.noResults);
            return;
          }
          const cacheId = normalized;
          if (Array.isArray(this.cache[cacheId])) {
            this.renderSearchResults(this.cache[cacheId]);
            this.setSearchStatus(
              this.cache[cacheId].length
                ? this.config.messages.results.replace('__COUNT__', String(this.cache[cacheId].length))
                : this.config.messages.noResults
            );
            return;
          }
          if (!this.canSearchExternally()) {
            this.renderSearchResults([]);
            this.setSearchStatus(this.config.messages.rateLimit);
            return;
          }
          this.setSearchStatus(this.config.messages.searching);
          this.searchAbortController = new AbortController();
          try {
            const url = new URL('https://itunes.apple.com/search');
            url.searchParams.set('term', query);
            url.searchParams.set('media', 'music');
            url.searchParams.set('entity', 'song');
            url.searchParams.set('limit', '8');
            url.searchParams.set('country', this.config.searchCountry || 'US');
            const response = await fetch(url, { signal: this.searchAbortController.signal });
            if (!response.ok) throw new Error('Search failed');
            const payload = await response.json();
            const results = (payload.results || []).slice(0, 8).map((track) => ({
              id: '',
              title: String(track.trackName || ''),
              artist: String(track.artistName || ''),
              album: String(track.collectionName || ''),
              artwork: String(track.artworkUrl100 || '').replace('100x100bb', '600x600bb'),
              link: String(track.trackViewUrl || ''),
              externalTrackId: String(track.trackId || ''),
              productionCode: 'PRO|CUSTOM',
              source: 'external-search'
            }));
            this.cache[cacheId] = results;
            this.writeSession(this.cacheKey, this.cache);
            this.renderSearchResults(results);
            this.setSearchStatus(
              results.length
                ? this.config.messages.results.replace('__COUNT__', String(results.length))
                : this.config.messages.noResults
            );
          } catch (error) {
            if (error.name === 'AbortError') return;
            this.renderSearchResults([]);
            this.setSearchStatus(this.config.messages.networkError);
          }
        }

        canSearchExternally() {
          const now = Date.now();
          const recent = this.readSession(this.rateKey, []).filter((timestamp) => now - timestamp < 60000);
          if (recent.length >= 20) return false;
          recent.push(now);
          this.writeSession(this.rateKey, recent);
          return true;
        }

        renderSearchResults(results) {
          const container = this.querySelector('[data-search-results]');
          if (!container) return;
          container.replaceChildren();
          container.hidden = results.length === 0;
          results.forEach((song) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'music-magnet__result';
            button.setAttribute('role', 'listitem');
            button.setAttribute('aria-pressed', String(this.state.song?.title === song.title && this.state.song?.artist === song.artist));
            if (song.artwork) {
              const image = document.createElement('img');
              image.src = song.artwork;
              image.alt = '';
              image.loading = 'lazy';
              button.append(image);
            } else {
              const placeholder = document.createElement('span');
              placeholder.className = 'music-magnet__result-placeholder';
              placeholder.setAttribute('aria-hidden', 'true');
              button.append(placeholder);
            }
            const copy = document.createElement('span');
            copy.className = 'music-magnet__result-copy';
            const title = document.createElement('span');
            title.textContent = song.title;
            const details = document.createElement('small');
            details.textContent = [song.artist, song.album].filter(Boolean).join(' · ');
            copy.append(title, details);
            const action = document.createElement('span');
            action.textContent = this.config.messages.select;
            button.append(copy, action);
            button.addEventListener('click', () => {
              this.clearManualFields();
              this.state.song = song;
              this.state.variant = this.variantBySku.get(this.config.customSku) || null;
              this.state.cover = this.config.albumArtworkEnabled ? 'album' : '';
              const albumCover = this.querySelector('[data-cover][value="album"]');
              if (albumCover) albumCover.checked = this.state.cover === 'album';
              const searchInput = this.querySelector('[data-search-input]');
              if (searchInput) searchInput.value = [song.title, song.artist].filter(Boolean).join(' — ');
              container.replaceChildren();
              container.hidden = true;
              this.setSearchStatus('');
              this.updateAll();
            });
            container.append(button);
          });
        }

        setSearchStatus(message) {
          const status = this.querySelector('[data-search-status]');
          if (status) status.textContent = message;
        }

        updateAll() {
          if (!this.config || !this.state) return;
          this.renderPresetSongs();
          this.updateCoverPanel();
          this.updateSummary();
          this.updateProperties();
          this.updateVariant();
          this.updateValidity(false);
        }

        updateCoverPanel() {
          const panel = this.querySelector('[data-upload-panel]');
          if (panel) panel.hidden = this.state.cover !== 'upload';
          const input = this.querySelector('[data-cover-file]');
          if (input) input.disabled = this.state.cover !== 'upload';
        }

        updateSummary() {
          const song = this.state.song;
          const songNode = this.querySelector('[data-summary-song]');
          const artistNode = this.querySelector('[data-summary-artist]');
          const coverNode = this.querySelector('[data-summary-cover]');
          if (songNode) songNode.textContent = song?.title || this.config.messages.noSong;
          if (artistNode) artistNode.textContent = song?.artist || (this.state.artist === 'Custom Artist' ? '' : this.state.artist);
          if (coverNode) {
            coverNode.textContent = this.state.cover === 'album'
              ? this.config.messages.album
              : this.state.cover === 'upload'
                ? this.config.messages.upload
                : this.config.messages.noCover;
          }
          const preview = this.querySelector('[data-preview-image]');
          const previewUrl = this.state.cover === 'upload'
            ? this.state.uploadUrl
            : song?.artwork || this.placeholderUrl;
          if (preview) {
            preview.hidden = !previewUrl;
            if (previewUrl) preview.src = previewUrl;
          }
        }

        updateProperties() {
          const song = this.state.song;
          const coverValue = this.state.cover === 'album' ? 'Album artwork' : this.state.cover === 'upload' ? 'Uploaded photo' : '';
          const productionSuffix = this.state.cover === 'upload' ? 'UPLOAD' : 'ALBUM';
          const values = {
            song: song?.title || '',
            artist: song?.artist || '',
            album: song?.album || '',
            cover: coverValue,
            link: song?.link || '',
            source: song?.source || '',
            catalog: song?.id || '',
            external: song?.externalTrackId || '',
            artwork: this.state.cover === 'album' ? song?.artwork || '' : '',
            production: song ? `${song.productionCode || 'PRO|CUSTOM'}|${productionSuffix}` : ''
          };
          Object.entries(values).forEach(([key, value]) => {
            const input = this.querySelector(`[data-property="${key}"]`);
            if (!input) return;
            input.value = value;
            if (['link', 'external'].includes(key)) input.disabled = !value;
          });
        }

        updateVariant() {
          const variant = this.state.variant;
          const idInput = this.form?.querySelector('[name="id"]');
          if (idInput) {
            idInput.value = variant?.id || '';
            idInput.disabled = !variant;
          }
          if (!variant) return;
          const priceRoot = document.getElementById(`price-${this.dataset.sectionId}`);
          if (priceRoot) {
            priceRoot.querySelectorAll('.price__regular .price-item--regular').forEach((node) => {
              node.textContent = variant.price;
            });
            priceRoot.querySelectorAll('.price__sale .price-item--sale').forEach((node) => {
              node.textContent = variant.price;
            });
            priceRoot.querySelectorAll('.price__sale .price-item--regular').forEach((node) => {
              node.textContent = variant.compareAt;
            });
          }
          const savings = this.querySelector('[data-savings]');
          if (savings) {
            savings.hidden = !variant.savingPercent;
            savings.textContent = this.config.messages.save
              .replace('__AMOUNT__', variant.saving)
              .replace('__PERCENT__', String(variant.savingPercent));
          }
          const mediaId = variant.featuredMediaId || this.state.song?.mediaId;
          if (mediaId && window.matchMedia('(min-width: 750px)').matches) {
            this.closest('product-info')?.querySelector('media-gallery')?.setActiveMedia?.(
              `${this.dataset.sectionId}-${mediaId}`,
              false
            );
          }
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }

        validate() {
          const errors = [];
          if (!this.state.artist) errors.push({ key: 'artist', message: this.config.messages.configuration });
          if (!this.state.song) errors.push({ key: 'song', message: this.config.messages.chooseSong });
          if (!this.state.cover) errors.push({ key: 'cover', message: this.config.messages.chooseCover });
          if (this.state.cover === 'upload' && !this.querySelector('[data-cover-file]')?.files?.length) {
            errors.push({ key: 'upload', message: this.config.messages.uploadRequired });
          }
          if (!this.state.variant) errors.push({ key: 'song', message: this.config.messages.configuration });
          return errors;
        }

        updateValidity(showErrors) {
          const errors = this.validate();
          ['artist', 'song', 'cover', 'upload'].forEach((key) => this.setError(key, ''));
          if (showErrors) errors.forEach((error) => this.setError(error.key, error.message));
          const canSubmit = errors.length === 0 && this.state.variant?.available;
          if (this.submitButton) {
            this.submitButton.disabled = !canSubmit;
            const text = this.submitButton.querySelector('span');
            if (text) text.textContent = this.state.variant && !this.state.variant.available
              ? this.config.messages.soldOut
              : this.config.messages.addToCart;
          }
          return { canSubmit, errors };
        }

        setError(key, message) {
          const node = this.querySelector(`[data-error-${key}]`);
          if (!node) return;
          node.textContent = message;
          node.hidden = !message;
        }

        onSubmit(event) {
          const validity = this.updateValidity(true);
          if (validity.canSubmit) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          const alert = this.querySelector('[data-form-alert]');
          if (alert) {
            alert.hidden = false;
            alert.textContent = validity.errors.map((error) => error.message).filter((message, index, all) => all.indexOf(message) === index).join(' ');
            alert.focus();
          }
          const firstError = validity.errors[0];
          if (firstError) this.querySelector(`[data-step="${firstError.key === 'upload' ? 'cover' : firstError.key}"]`)?.scrollIntoView({ block: 'center' });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
